export default __webpack_public_path__ + "static/media/pandora.b6ac03a6.svg";